import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import styled from 'styled-components';
import { Row } from 'antd';
export default styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  ", "\n"])), function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});
var HeaderContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0;\n\n  @media only screen and (max-width: ", ") {\n    flex-direction: column;\n    margin-bottom: 0.5em;\n    align-items: flex-start;\n  }\n\n  ", "\n"])), function (props) {
  return props.theme.layout.mainLayoutSection.padding;
}, function (props) {
  var _props$theme$breakpoi;

  return ((_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm) && '576px';
}, function (props) {
  return props.theme.layout.mainLayoutSection.responsivePadding && "\n    @media only screen and (max-width: ".concat(props.theme.breakpoints.sm, ") {\n      padding: ").concat(props.theme.layout.mainLayoutSection.responsivePadding, ";\n    } \n  ");
});
var ToolbarContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var TitleContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-top: 1rem;\n  display: flex;\n  flex-direction: column;\n\n  & h2 {\n    font-weight: bold;\n    font-size: 2.5rem;\n    padding: 0;\n    margin: 0;\n\n    @media only screen and (max-width: ", ") {\n      font-size: 2rem;\n    }\n  }\n"])), function (props) {
  var _props$theme$breakpoi2;

  return ((_props$theme$breakpoi2 = props.theme.breakpoints) === null || _props$theme$breakpoi2 === void 0 ? void 0 : _props$theme$breakpoi2.sm) && '576px';
});
export function Title(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? '' : _ref$children,
      _ref$dataTestid = _ref['data-testid'],
      dataTestId = _ref$dataTestid === void 0 ? 'headerTitle' : _ref$dataTestid,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
      _ref$toolbar = _ref.toolbar,
      toolbar = _ref$toolbar === void 0 ? null : _ref$toolbar;
  return /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement("h2", {
    "data-testid": dataTestId
  }, children), /*#__PURE__*/React.createElement("h3", {
    "data-testid": "".concat(dataTestId, "Secondary")
  }, subtitle)), toolbar && /*#__PURE__*/React.createElement(ToolbarContainer, null, toolbar));
}